export const headingStyles = {
  // Styles for the base style
  baseStyle: {},
  // Styles for the size variations
  sizes: {},
  // Styles for the visual style variations
  variants: {
    topBar: {
      color: "#66CCB5",
      mx: "1vw",
      cursor: "pointer",
    },
  },
  // The default `size` or `variant` values
  defaultProps: {},
};
